import React from "react";

function LiveView() {
  return (
    <span className="anticon anticon-liveview">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 10 8"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M5.085 2.001A1.503 1.503 0 006.5 4c.438 0 .831-.187 1.106-.486a3 3 0 11-2.782-1.509L5 2l.085.001zM5 0a5.5 5.5 0 014.89 2.98l.103.212-.907.42a4.5 4.5 0 00-8.006-.325l-.103.194-.893-.45A5.5 5.5 0 015 0z"
        ></path>
      </svg>
    </span>
  );
}

export default LiveView;
